export default __webpack_public_path__ + "static/media/logo.39ece8e9.svg";